import React, { useContext , useState} from 'react'
import Hero from '../../components/front/Hero'

import GlobalStateContext from '../../context';
import { Redirect } from 'react-router-dom';
import { url } from '../../utils';
import { protectedRoutesPrefix } from '../../routers/routes';
import TrustedBrands from '../../components/front/TrustedBrands';
import LiveEvents from '../../components/front/LiveEvents';
import ShortFooter from '../../components/front/ShortFooter';
import Events from '../../components/front/Events';
import TopChannels from '../../components/front/TopChannels';
import Header from '../../components/front/Header';




export default function Landing() {
    const [state] = useContext(GlobalStateContext);
    const [showLiveEvent,setShowLive] = useState(true);
    const onLiveReady = (items)=>{
        // console.log();
        setShowLive(items.length > 0)
    }

    return (
        <>
            {
                // state.user ?
                //     <Redirect to={ url(protectedRoutesPrefix) } /> :

                    <div className='landing-body'>
                        <Hero/>
                        {/* <TrustedBrands/> */}
                        {/* <TopChannels/> */}
                        <Events/>
                        {/* <Features />
                        <Pricing /> */}
                        {/* <About/> */}
                        
                    

                    {/* <ShortFooter/> */}
                    </div>
            }
        </>
    )
}
